import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Template from "@/services/template/template";
import type { EditTemplate } from "@/dtos/Template.dto";

export function useUpdateTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: EditTemplate) => {
      const result = await Template.editTemplate(payload);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update template");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });
}
